
import EoCheckboxGroup from '../EoCheckboxGroup/EoCheckboxGroup'
import EoCheckbox from '../EoCheckboxGroup/EoCheckbox'

export default {
  name: 'EoSearchFilterList',
  components: {
    EoCheckbox,
    EoCheckboxGroup,
  },
  props: {
    darkMode: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    /*
     * Style: color used on buttons
     */
    buttonColor: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      filters: {},
    }
  },
  computed: {
    classes () {
      return {
        'eo-search-filter-list': true,
        'text--grey-700': true,
      }
    },
  },
  watch: {
    value: 'onUpdatedValue',
    filters: 'onUpdatedFilters',
  },
  created () {
    this.onUpdatedValue()
  },
  methods: {
    onUpdatedValue () {
      this.filters = this.value
    },
    onUpdatedFilters (filters) {
      /**
       * Emitted when the filters have changed
       * @event input
       */
      this.$emit('input', filters)
    },
    isOptionSelected (filter, optionName) {
      return filter.selected?.some((option) => {
        return option === optionName
      })
    },
  },
}
